import { mapState, mapGetters } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'

export const PersonalDetails = {
  name: 'PersonalDetails',
  props: {
    focusedField: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      isFilled: false,
      personalDetails: this.$store.state.checkout.personalDetails,
      createAccount: false,
      acceptConditions: false,
      password: '',
      rPassword: '',
      isValidationError: false
    }
  },
  mounted () {
    if (!this.isLoggedIn) {
      let localStorageData = JSON.parse(localStorage.getItem('shop/checkoutFieldValues/personal-details'))
      this.loadDataFromStorage(this.personalDetails, localStorageData)
    } else if (!this.personalDetails.email) {
      this.onLoggedIn(this.currentUser)
    }
    this.addPhoneNumber()
    this.sendDataToCheckout()
  },
  computed: {
    ...mapState({
      currentUser: (state: RootState) => state.user.current
    }),
    ...mapGetters({
      isVirtualCart: 'cart/isVirtualCart',
      isLoggedIn: 'user/isLoggedIn'
    })
  },
  methods: {
    onLoggedIn (receivedData) {
      this.personalDetails = {
        firstName: receivedData.firstname,
        lastName: receivedData.lastname,
        emailAddress: receivedData.email,
        phoneNumber: receivedData.telephone
      }
    },
    sendDataToCheckout () {
      if (this.createAccount) {
        this.personalDetails.password = this.password
        this.personalDetails.createAccount = true
      } else {
        this.personalDetails.createAccount = false
      }
      let userEmail = 'User: ' + this.personalDetails.email;
      /* if (!isServer && Object.keys(window.hj).length > 0) {
        window.hj('tagRecording', [userEmail]);
      } */
      this.$bus.$emit('checkout-after-personalDetails', this.personalDetails, this.$v)
      this.isFilled = true
      this.isValidationError = false
    },
    edit () {
      if (this.isFilled) {
        this.$bus.$emit('checkout-before-edit', 'personalDetails')
      }
    },
    gotoAccount () {
      this.$bus.$emit('modal-show', 'modal-signup')
    },
    addPhoneNumber () {
      if (this.currentUser) {
        this.personalDetails.phoneNumber = this.currentUser.telephone
      }
    },
    loadDataFromStorage (objFirst, objSecond) {
      if (!objFirst || !objSecond) {
        return;
      }
      Object.keys(objFirst).map(key => {
        objFirst[key] = objSecond[key] ? objSecond[key] : objFirst[key]
      })
    }
  },
  updated () {
    // Perform focusing on a field, name of which is passed through 'focusedField' prop
    if (this.focusedField && !this.isValidationError) {
      if (this.focusedField === 'password') {
        this.isValidationError = true
        this.password = ''
        this.rPassword = ''
        this.$refs['password'].setFocus('password')
      }
    }
  },
  watch: {
    personalDetails: {
      deep: true,
      handler: function () {
        this.sendDataToCheckout()
      }
    }
  },
  beforeMount () {
    this.$bus.$on('user-after-loggedin', this.onLoggedIn)
  },
  destroyed () {
    this.$bus.$off('user-after-loggedin', this.onLoggedIn)
  }
}
